import React from 'react';
import '../App.css';
import $ from 'jquery';
import config from '.././config.json';
import GradeStudent from './GradeStudent';
import moment from 'moment';

import { Redirect } from 'react-router';
import LoginForm from '../LoginForm.js';

import { Table, Input, Badge, Modal, notification, Form, Select, Row, Col } from 'antd';
import UpdateEnrollmentModalForm from './UpdateEnrollmentModalForm';
import { JSONToCSVConvertor } from '../Helpers/ExportToExcel';

const FormItem = Form.Item;
const { Option } = Select;

class GradeClass extends React.Component {

    constructor(props) {
        super(props);
    }

    state = {
        classData: [],
        gradeData: {},
        login: true,
        classname: '',
        classMode: '',
        sortedInfo: null,
        visibleWarning: false,
        selectedRowKeys: [],
        selectedRows: [],
        recordUpdate: '',
        filterSystem: "All",
        filterMonths: "All"
    };
    recordD = '';
    studentNameGrade = '';
    updateModalTitle = '';

    componentDidMount() {
        LoginForm.ValidateServerToken(
            () => { this.setState({ login: false }) }, //logout
            () => { this.refresh(); }); //login
    }

    componentWillUnmount() {
        if (this.state.classSelected) {
            this.setState({ classSelected: false });
            window.location.hash = "/admin/grade";
        }
        else {
            window.location.hash = "/admin/admin";
        }
    }

    /**
     * Refresh class list
     */
    refresh() {
        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/classes/getall`
        })
            .done((data) => {
                
                if (this.state.filterSystem != "All") {
                    data = data.filter(x => x.SystemName == this.state.filterSystem);
                }

                if (this.state.filterMonths && this.state.filterMonths != "All") {
                    let endDate = this.getDateBeforeMonths(this.state.filterMonths);
                    endDate = new Date(endDate);
                    data = data.filter(item => {
                        const startDate = new Date(item.StartDate);
                        return startDate > endDate;
                    });
                }

                this.setState({
                    classData: data
                });
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('failed to get data');
            });
    }

    getDateBeforeMonths(months) {
        const date = new Date();
        date.setMonth(date.getMonth() - months); // Subtract months
        return date;
    }

    // These functions are for the search drop down
    onInputChange = (e) => {
        this.setState({ searchText: e.target.value });
    }

    /**
     * Get all the students for a class
     * @param {any} record
     */
    gradeClass(record) {
        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getclassstudentsemp/` + record.Id
        })
            .done((data) => { // cert_classmanagelist objects returned
                this.setState({
                    classData: data, // list students
                    classId: record.Id,
                    classSelected: true,
                    classname: record.Name
                });
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('failed to get data');
            });

        // ** get the name of the class mode for comparison later in update enrollment submit **
        // since this method is called in the onOk methods, it doesn't always have record.classmodeId, 
        // but we don't need to update classmode string in those two cases
        if (record.ClassModeID !== undefined) {
            $.ajax({
                type: 'GET',
                url: `${config.serverUrl}/api/classes/getMode?modeid=` + record.ClassModeID
            })
                .done((data) => {
                    this.setState({ classMode: data });
                })
                .fail((jqXHR, textStatus, errorThrown) => {
                    this.openNotificationWithIcon("error", "Server Failure", "Failed to get class mode data. Please close the updater and try again.");
                });
        }


        this.setState({
            classSelected: true
        })
    }

    /**
     * Get data for student to be graded
     * @param {any} record
     */
    gradeStudent(record) {
        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getstudenttests/` + this.state.classId + '/' + record.StudentId
        })
            .done((data) => {
                this.studentNameGrade = "Grade: " + record.FirstName + " " + record.LastName;
                this.setState({
                    gradeData: data[0],//Needs to be updated to accept more than one class to update
                    classSelected: true
                })
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('failed to get data');
            });

        this.showModal();

    }

    /**
    * Open Notification window
    */
    openNotificationWithIcon = (type, title, body) => {
        notification[type]({
            message: title,
            description: body,
        });
    };

    /**
    * Callback after student has been graded
    */
    handleOk = (e) => {
        console.log(e);
        //refresh the students table 
        this.gradeClass({ Id: this.state.classId, Name: this.state.classname });
        this.setState({
            visible: false,
            selectedRowKeys: [],
            selectedRows: []
        });

    }

    /**
    * Callback for canceling student grading
    */
    handleCancel = (e) => {
        console.log(e);
        this.setState({
            visible: false,
        });
    }

    /**
    * Opens the modal with the form to grad a student
    */
    showModal = () => {
        this.setState({
            visible: true,
        });
    }

    deleteStudent = (record, emailS) => {
        alert("The deletion process may take a while, please just wait for the next popup to see the list update.")
        var validEmails = this.validateEmails(emailS);
        if (validEmails) {
            $.ajax({
                type: 'POST',
                url: `${config.serverUrl}/api/classes/deleteenrollment`,
                data: { studentId: record.StudentId, classId: this.state.classId, studentEmail: record.Email, className: this.state.classname, email: emailS, studentFname: record.FirstName, studentLname: record.LastName }
            })
                .done((data) => {
                    console.log(data);
                    this.gradeClass({ Id: this.state.classId });
                    this.setState({ loading: false })
                    alert("Enrollment Deleted.")
                })
                .fail((jqXhr) => {
                    console.log('failed to get employer');
                });
        } else {
            Modal.error({
                title: "Error",
                content: "Deletion failed! One or more emails provided were invalid."
            });
        }

    }

    validateEmails = (emails) => {
        //console.log(typeof(emails));
        var emailSplit = [];
        if (emails.includes(";")) {
            emailSplit = emails.split(";");
        } else {
            emailSplit.push(emails);
        }
        //var emailsplit;
        var valid = emailSplit.every((addr) => {
            return addr.match(
                // email validation regex https://stackoverflow.com/questions/46155/whats-the-best-way-to-validate-an-email-address-in-javascript
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
        });

        return valid;
    }

    handleChangeSort = (pagination, filters, sorter) => {
        this.setState({
            sortedInfo: sorter,
        });
    }


    compareByChar(a, b) { if (a > b) { return -1; } if (a < b) { return 1; } return 0; }


    onSelectChange = (selectedRowKeys, selectedRows) => {

        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        this.setState({
            selectedRowKeys: selectedRowKeys,
            selectedRows: selectedRows
        });
    };

    passAll = () => {
        if (typeof this.state.selectedRows !== 'undefined' && this.state.selectedRows.length > 1) {
            this.studentNameGrade = "Grading Multiple Students";
            this.setState({
                gradeData: [],
                classSelected: true
            })
            this.showModal();
        }

        else {
            notification["error"]({
                message: 'Error',
                description: 'Select more than two students to use this feature!',
            });
        }
    }


    /**
     * Render function
     */
    render() {
        const { getFieldDecorator } = this.props.form;
        const { selectedRowKeys, selectedRows } = this.state;
        const rowSelection = {
            selectedRowKeys,
            selectedRows,
            onChange: this.onSelectChange,
        };
        //Classes table
        let { sortedInfo } = this.state;
        sortedInfo = sortedInfo || {};
        const classColumns = [
            {
                title: 'Class',
                dataIndex: 'Name',
                key: 'Id',
                sorter: (a, b) => this.compareByChar(a.Name, b.Name),
                sortOrder: sortedInfo.columnKey === 'Id' && sortedInfo.order

            },

            {
                title: 'Start Date',
                dataIndex: 'StartDate',
                render: (text, record, index) => {
                    return (
                        <span>
                            {moment(text).format('l')}
                        </span>
                    );
                },
                sorter: (a, b) => this.compareByChar(a.StartDate, b.StartDate),
                sortOrder: sortedInfo.columnKey === 'StartDate' && sortedInfo.order,
            },
            {
                title: 'End Date',
                dataIndex: 'EndDate',
                render: (text, record, index) => {
                    return (
                        <span>
                            {moment(text).format('l')}
                        </span>
                    );
                },
            },
            {
                title: 'Cost',
                dataIndex: 'Cost',
            },
            {
                title: 'Action',
                dataIndex: 'edit',
                render: (text, record, index) => {
                    return (
                        <div className="editable-row-operations">
                            <span>
                                <a onClick={() => this.gradeClass(record)}>Manage</a>
                            </span>
                        </div>
                    );
                }
            }
        ];
        //Students table
        const studentsColumns = [
            {
                title: 'First Name',
                dataIndex: 'FirstName',
                // specify the condition of filtering result
                // here is that finding the name started with `value`
                key: 'FirstName',
                sorter: (a, b) => this.compareByChar(a.FirstName, b.FirstName),
                sortOrder: sortedInfo.columnKey === 'FirstName' && sortedInfo.order

            },

            {
                title: 'Last Name',
                dataIndex: 'LastName',
                sorter: (a, b) => this.compareByChar(a.LastName, b.LastName),
                sortOrder: sortedInfo.columnKey === 'LastName' && sortedInfo.order
            },
            {
                title: 'Tech ID',
                dataIndex: 'TechID',
                sorter: (a, b) => a.TechID - b.TechID,
                sortOrder: sortedInfo.columnKey === 'TechID' && sortedInfo.order,
            },
            {
                title: "Attendance",
                dataIndex: "AttendanceSelection",
                sorter: (a, b) => a.AttendanceSelection > b.AttendanceSelection,
                sortOrder: sortedInfo.columnKey === "AttendanceSelection" && sortedInfo.order
            },
            {
                title: 'Employer',
                dataIndex: 'CompanyName',
                render: (text, record, index) => {
                    let emp = 'Not Available';
                    if (record.CompanyName) {
                        emp = record.CompanyName + ", " + record.EmployerCity + " (" + record.EmployerState + ")"
                    }
                    return (
                        <div>{emp}</div>
                    );
                },
            },
            {
                title: 'Status',
                dataIndex: 'GradeCriteria',
                render: (text, record, index) => {
                    return (
                        <div className="editable-row-operations">
                            {record.GradeCriteria == "Not Graded" && <span><Badge status="error" />Not Graded</span>}
                            {record.GradeCriteria != "Not Graded" && <span><Badge status="success" />{record.GradeCriteria}</span>}
                        </div>
                    );
                },
            },

            {
                title: 'Action',
                dataIndex: 'grade',
                render: (text, record, index) => {
                    return (
                        <div className="editable-row-operations">
                            <span>
                                <a onClick={() => this.gradeStudent(record)}>Grade</a>|

                                <a onClick={() => { this.showModalW(record) }}> Delete</a>|

                                <a onClick={() => { this.updateStudent(record) }}> Update</a>
                            </span>
                        </div>
                    );
                }
            }
        ];
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };
        // render stuff.. finally...
        return (
            <div>
                {this.state.login ?
                    <div>
                        <Modal
                            key={this.state.gradeData.Id}
                            title={this.studentNameGrade}
                            visible={this.state.visible}
                            onOk={this.handleOk}
                            onCancel={this.handleCancel}
                            footer={[]}>
                            <GradeStudent updateFields={this.state.gradeData} updateEvent={this.handleOk} multipleData={this.state.selectedRows} gradingClassId={this.state.classId} />
                        </Modal>
                        {/* no classes selected, display the table to choose */}
                        {!this.state.classSelected &&
                            <div>
                                <h2>Manage Class</h2>
                                <hr />
                                <Row>
                                    <Col span={14}>
                                        <FormItem
                                            label="Certification System"
                                            {...formItemLayout}>
                                            {getFieldDecorator('system', {
                                                initialValue: this.state.filterSystem
                                            })(<Row gutter={8}>
                                                <Col span={18}>
                                                    <Select style={{ width: 400 }}
                                                        placeholder="Select the system this class belongs to"
                                                        onChange={this.handleSelectChangeSystem}>
                                                        <Option value="All">All</Option>
                                                        <Option value="TCP">TCP</Option>
                                                        <Option value="ESCC">ESCC</Option>
                                                        <Option value="External Civil Rights Training">External Civil Rights Training</Option>
                                                    </Select>
                                                </Col>
                                            </Row>

                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={10}>
                                        <FormItem
                                            label="Filter"
                                            {...formItemLayout}>
                                            {getFieldDecorator('system', {
                                                initialValue: this.state.filterMonths
                                            })(<Row gutter={12}>
                                                <Col span={18}>
                                                    <Select style={{ width: 200 }}
                                                        placeholder="Select a filter value"
                                                        onChange={this.handleFilterChange}>
                                                        <Option value="3">Past 3 months</Option>
                                                        <Option value="6">Past 6 months</Option>
                                                        <Option value="12">Past 1 year</Option>
                                                        <Option value="24">Past 2 years</Option>
                                                        <Option value="All">All</Option>
                                                    </Select>
                                                </Col>
                                            </Row>

                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>

                                {/* <Select
                                    style={{ width: 830 }}
                                    placeholder="Select the system the classes belong to"
                                    onChange={this.handleSelectChangeSystem}>
                                    <Option value="All">All</Option>
                                    <Option value="TCP">TCP</Option>
                                    <Option value="ESCC">ESCC</Option>
                                    <Option value="External Civil Rights Training">External Civil Rights Training</Option>
                                </Select>
                                <hr /> */}
                                <Table rowKey="Id" bordered columns={classColumns}
                                    onChange={this.onChange}
                                    dataSource={this.state.classData}
                                    onChange={this.handleChangeSort}
                                    pagination={{ pageSize: 30, current: this.state.current, onChange: (page, pageSize) => { this.setState({ current: page }) } }}
                                />
                            </div>
                        }
                        {/* class selected, display info and table of enrolled students */}
                        {this.state.classSelected &&
                            <div>
                                <h2>Manage Class </h2>
                                <h4>{this.state.classname}</h4>
                                <h4>Class availability offered: {this.state.classMode}</h4>
                                <hr />
                                <Table rowKey="Id" bordered columns={studentsColumns}
                                    rowSelection={rowSelection}
                                    onChange={this.onChange}
                                    dataSource={this.state.classData}
                                    onChange={this.handleChangeSort}
                                    pagination={{ pageSize: 30 }}
                                //scroll={{ y: 240 }}
                                />
                                <button onClick={() => { this.setState({ classSelected: false }); this.refresh(); }} style={{ margin: 5 }} className="btn btn-default" >Back</button>
                                <button onClick={() => { this.passAll() }} style={{ margin: 5, float: 'right' }} className="btn btn-default">Grade Selected Student(s)</button>
                                <button onClick={() => { this.updateAll() }} style={{ margin: 5, float: 'right' }} className="btn btn-default">Update Students Attendance</button>
                                <button onClick={() => { this.getExcel() }} style={{ margin: 5, float: 'right' }} className="btn btn-default" >Export to Excel</button>

                                <Modal
                                    visible={this.state.visibleWarning}
                                    title="Do you want delete this enrollment?"
                                    okText="Delete"
                                    onCancel={() => { this.onCancelW() }}
                                    onOk={() => { this.onDeleteW() }}
                                >
                                    <Form >
                                        <FormItem label="To receive a copy of the email notification. Enter your email:">
                                            {getFieldDecorator('EmailW', {
                                                rules: [{ required: true, message: 'Please input your email!', whitespace: true }],
                                            })(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Form>
                                    Note: Separate multiple email using semicolon(;)
                                </Modal>


                                <Modal
                                    visible={this.state.visibleUpdate}
                                    title={this.updateModalTitle}
                                    okText="Update"
                                    onCancel={this.onCancelUpdate}
                                    onOk={this.onOKUpdate}
                                    footer={[]}
                                >
                                    <UpdateEnrollmentModalForm
                                        updateFields={this.state.recordUpdate} updateEvent={this.onOKUpdate} // update event is for cancel??
                                        multipleData={this.state.selectedRows} updatingClassId={this.state.classId}
                                        classMode={this.state.classMode}>
                                    </UpdateEnrollmentModalForm>
                                </Modal>

                            </div>
                        }
                    </div>
                    : <Redirect to="/login" replace />
                }
            </div>
        );
    }

    handleSelectChangeSystem = (value) => {
        this.setState({ filterSystem: value });
        this.refresh()
    }

    handleFilterChange = (value) => {
        this.setState({ filterMonths: value });
        this.refresh()
    }

    showModalW = (record) => {
        this.setState({ visibleWarning: true });
        this.recordD = record;
    }
    onCancelW = () => {
        this.setState({ visibleWarning: false });
    }
    onDeleteW = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                return;
            }
            else {
                this.props.form.resetFields();
                this.setState({ visibleWarning: false });
                this.deleteStudent(this.recordD, values.EmailW);

            }
        });
    }
    updateStudent = (record) => {
        this.updateModalTitle = "Please update the student's attendance selection"
        this.showModalUpdate(record);
    }
    updateAll = () => {
        if (typeof this.state.selectedRows !== 'undefined' && this.state.selectedRows.length > 1) {
            this.updateModalTitle = "Please update all selected students' attendance selections";
            this.setState({
                gradeData: [],
                classSelected: true
            })
            this.showModalUpdate();
        }
        else {
            notification["error"]({
                message: 'Error',
                description: 'Select at least two students to use this feature!',
            });
        }
    }
    showModalUpdate = (record) => {
        this.setState({
            visibleUpdate: true,
            recordUpdate: record
        });
    }
    onCancelUpdate = () => {
        this.setState({
            visibleUpdate: false,
            loading: false
        });
        this.props.form.resetFields();
    }
    /**
     * passed to update enrollment component so close the modal on successful update
     */
    onOKUpdate = () => {

        this.gradeClass({ Id: this.state.classId, Name: this.state.classname });
        this.setState({
            visibleUpdate: false,
            selectedRowKeys: [],
            selectedRows: []
        });
    }

    getExcel = () => {

        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getexcelexport/` + this.state.classId
        })
            .done((data) => {

                JSONToCSVConvertor(data, this.state.classname, true, 'text/csv;encoding:utf-8');
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.error('failed to get data');
            });


    }

}
const WrappedGradeClass = Form.create()(GradeClass);
export default WrappedGradeClass;


// WEBPACK FOOTER //
// ./src/Admin/GradeClass.js